<template>
  <div class="tw-inline-block">
    <IconButton
      color="outline-secondary"
      @click="openModal(ADD_TOOL_MODAL_NAME)"
    >
      <PlusIcon />
    </IconButton>

    <ToolkitModal :name="ADD_TOOL_MODAL_NAME" mode="ADD" />
  </div>
</template>

<script setup>
import IconButton from '@/shared/components/IconButton.vue'
import ToolkitModal from './ToolkitModal.vue'
import PlusIcon from '@/assets/images/icons/plus.svg'
import { ADD_TOOL_MODAL_NAME } from '@/shared/data/globalVariables.js'
import { useModals } from '@/shared/composables/useModals.js'

const { openModal } = useModals()
</script>
